import { queryOptions } from '@tanstack/react-query';
import { presetKeys } from '@shared/api/query-keys';
import { presetsApi } from './presets';

/**
 * Co-located `queryOptions` for the presets domain (reference impl, P0). Defining
 * key + queryFn once lets hooks, prefetch, and typed `getQueryData`/`setQueryData`
 * all share a single source of truth. Per-call overrides (`enabled`, `staleTime`)
 * stay at the hook call site.
 */
export const presetQueries = {
  list: () =>
    queryOptions({
      queryKey: presetKeys.all(),
      queryFn: () => presetsApi.getPresets(),
    }),
};
